module.exports = __webpack_public_path__ + "static/media/IconRewardsActive.6f1e33d7.svg";